import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { PaginationBox } from "./ServiceDistributionStyled";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import TableSortLabel from "@mui/material/TableSortLabel";
export const ServiceDistribution = ({
    headers,
    rows,
    countrlist,
    countries,
    componentList,
    isEditable,
    onTextChange,
}) => {
    const [page, setPage] = React.useState(1);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    countries?.map((item) => {
        item.headCount = countrlist?.find(
            (x) => x.countryName === item.countryName
        )?.headcount;
    });

    const emptyRows =
        rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

    function getUtilValue(countryId, productId, productVariationId, componentId) {
        const obj = rows.find(
            (x) =>
                x.countryId === countryId &&
                x.productId === productId &&
                x.productVariationId === productVariationId &&
                x.componentId === componentId
        );
        return Number(obj.utilizationPercent.toFixed(2)).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
        });
    }
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("countryName");
    const createSortHandler = (property) => (event) => {
        setOrder(order == "asc" ? "desc" : "asc");
        setOrderBy(property);
    };
    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === "desc"
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) {
                return order;
            }
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }
    return (
        <div>
            <TableContainer component={Paper}>
                <Table className="servicetable" aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center"
                                }}>
                                    Country
                                    {
                                        <TableSortLabel
                                            active={orderBy === "countryName"}
                                            direction={orderBy === "countryName" ? order : "desc"}
                                            onClick={createSortHandler("countryName")}
                                        ></TableSortLabel>
                                    }
                                </div>
                            </TableCell>
                            <TableCell>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center"
                                }}>
                                    Head Count
                                    {
                                        <TableSortLabel
                                            active={orderBy === "headCount"}
                                            direction={orderBy === "headCount" ? order : "desc"}
                                            onClick={createSortHandler("headCount")}
                                        ></TableSortLabel>
                                    }
                                </div>
                            </TableCell>
                            <TableCell>Product</TableCell>
                            <TableCell>Product Variation</TableCell>
                            {headers.map((header) => (
                                <TableCell key={header.componentId}>
                                    {header.componentName}(%)
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(rowsPerPage > 0
                            ? stableSort(countries, getComparator(order, orderBy)).slice(
                                (Number(page) - 1) * rowsPerPage,
                                (Number(page) - 1) * rowsPerPage + rowsPerPage
                            )
                            : countries
                        ).map((row) => (
                            <TableRow key={row.id}>
                                <TableCell className="countryrow">
                                    {row.countryName}
                                </TableCell>
                                <TableCell>{row?.headCount?.toLocaleString()}</TableCell>
                                <TableCell>{row.productName}</TableCell>
                                <TableCell>{row.productVariationName}</TableCell>
                                {headers.map((cell) => (
                                    <TableCell key={cell.id}>
                                        {getUtilValue(
                                            row.countryId,
                                            row.productId,
                                            row.productVariationId,
                                            cell.componentId
                                        )}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <PaginationBox>
                <Typography variant="h6">
                    {countries.length}
                    <span>Total Results</span>
                </Typography>
                <Pagination
                    count={Math.ceil(countries.length / rowsPerPage)}
                    page={page}
                    onChange={handleChangePage} // Use onChange for page changes
                // Use onRowsPerPageChange for rows per page changes
                />
            </PaginationBox>
        </div>
    );
};

export default ServiceDistribution;
